import React from 'react';
import PropTypes from 'prop-types';

import { Headline, Richtext, TextInput, Button } from '../../elements';
import styles from './CaptchaForm.module.scss';

const CaptchaForm = ({ captchaQuestion, onResolveCaptcha }) => {
	const [captchaValue, setCaptchaValue] = React.useState('');

	return (
		<div className={styles.wrapper}>
			<Headline variant='h3'>Prüfung der Anfrage</Headline>
			<Richtext>
				<p>
					Zum Schutz unserer Daten müssen wir sicherstellen, dass Sie ein realer Nutzer sind. Bitte
					lösen Sie hierzu die folgende Frage:
				</p>
			</Richtext>

			<TextInput
				name='captcha_value'
				label={captchaQuestion}
				onChange={(e) => setCaptchaValue(e.target.value)}
			/>

            <Button title='Senden' onClick={() => onResolveCaptcha(captchaValue)} />
		</div>
	);
};

CaptchaForm.propTypes = {
    captchaQuestion: PropTypes.string.isRequired,
    onResolveCaptcha: PropTypes.func.isRequired,
};

export default CaptchaForm;
